// PATCH Maison Bagages 2026-10-07 : la barre flottante de Ralph (JUST, <just-ai-agent>, z-index 999998) recouvrait
// la barre « Ajouter au panier » collante de FullStack sur les fiches produit (mobile et desktop). Quand la barre collante est active,
// on remonte la barre JUST de sa hauteur (même animation 300 ms). JUST n'a aucun réglage de décalage : style injecté
// dans son shadow DOM (ouvert), piloté par la variable --mb-just-offset posée sur l'hôte.
// Chargé par blocks/_product-add-to-cart-button.liquid (patché) quand la barre collante est activée.
// Mobile : pastille .just-ai-pill-bar (sans transform propre). Desktop : barre centrée .just-ai-trigger, qui porte déjà
// transform (centrage) et translate (son animation, transition recopiée telle quelle) : on la remonte par margin-bottom.
const CSS = '.just-ai-pill-bar{transform:translateY(calc(-1 * var(--mb-just-offset, 0px)));transition:transform 300ms ease-in-out}'
  + '.just-ai-trigger{margin-bottom:var(--mb-just-offset, 0px);transition:translate .6s cubic-bezier(.16,1,.3,1),visibility .6s,margin-bottom 300ms ease-in-out}';
const stickies = [...document.querySelectorAll('sticky-add-to-cart')];

function inject(host) {
  const root = host.shadowRoot;
  if (!root || root.querySelector('style[data-mb-just]')) return;
  const style = document.createElement('style');
  style.dataset.mbJust = '';
  style.textContent = CSS;
  root.appendChild(style);
}

function update() {
  const offset = stickies.reduce((max, s) => {
    const content = s.dataset.active === 'true' && s.querySelector('.sticky-add-to-cart__content');
    return content ? Math.max(max, content.offsetHeight) : max;
  }, 0);
  document.querySelectorAll('just-ai-agent').forEach((host) => {
    inject(host);
    host.style.setProperty('--mb-just-offset', `${offset}px`);
  });
}

if (stickies.length) {
  const observer = new MutationObserver(update);
  stickies.forEach((s) => observer.observe(s, { attributes: true, attributeFilter: ['data-active'] }));
  customElements.whenDefined('just-ai-agent').then(() => requestAnimationFrame(update));
  update();
}
